import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { SearchConditionState } from '../SearchConditionReducer';

export interface SearchCustomerListConditionState {
  currentPage: number;
  sortKey: string;
  filterState: SearchConditionState;
}

export const initialState: SearchCustomerListConditionState = {
  currentPage: 1,
  sortKey: '001',
  filterState: [],
};

export const SearchCustomerListConditionReducer = reducerWithInitialState(initialState)
  .case(actions.updateCustomerListSearchCondition.init, () => {
    return {
      ...initialState,
    };
  })
  .case(actions.updateCustomerListSearchCondition.changeSortKey, (state: SearchCustomerListConditionState, payload: string) => {
    return {
      ...state,
      sortKey: payload,
    };
  })
  .case(actions.updateCustomerListSearchCondition.changeCurrentPage, (state: SearchCustomerListConditionState, payload: number) => {
    return {
      ...state,
      currentPage: payload,
    };
  })
  .case(
    actions.updateCustomerListSearchCondition.changeFilterState,
    (state: SearchCustomerListConditionState, payload: SearchConditionState) => {
      return {
        ...state,
        filterState: payload,
      };
    },
  );
